// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/styles/less/application.less
// module id = 105
// module chunks = 0